<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card min-height="50vh">

      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>{{ $t('User log') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-tabs>
          <v-tab @click="activeTab='general'">
            General
          </v-tab>
          <v-tab  @click="activeTab='oldvalues'">
            Old values
          </v-tab>
          <v-tab @click="activeTab='newvalues'">
            New values
          </v-tab>
          <v-tab @click="activeTab='changed'">
            Changed values
          </v-tab>
        </v-tabs>

        <template v-if="model.data && activeTab == 'general'">
          <v-simple-table
            fixed-header

          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>Data key</strong>
                  </th>
                  <th class="text-left">
                    <strong>Value</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="model.involved_id">
                  <td>Involed ID#</td>
                  <td>{{ model.involved_id }}</td>
                </tr>
                <tr>
                  <td>Action</td>
                  <td>{{ model.action }}</td>
                </tr>
                <tr>
                  <td>At</td>
                  <td>{{ created_at }}</td>
                </tr>
                <tr>
                  <td>By</td>
                  <td>{{ model.responsible_user }}</td>
                </tr>
                <tr>
                  <td>Module</td>
                  <td>{{ model.module }}</td>
                </tr>                
                <tr>
                  <td>Request</td>
                  <td>{{ model.request }}</td>
                </tr>                
                <tr>
                  <td>Requested id</td>
                  <td>{{ model.request_id }}</td>
                </tr>                

              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.data && activeTab=='changed'">
          <v-simple-table
            fixed-header

          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>Data key</strong>
                  </th>
                  <th class="text-left">
                    <strong>Old Value</strong>
                  </th>
                  <th class="text-left">
                    <strong>New Value</strong>
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data_value, data_key) in JSON.parse(model.changes)"
                  :key="data_key"
                >
                  <td>{{ data_key }}</td>

                  <td v-if="isJson(data_value.oldvalue)">
                    <li v-for="(xtra_data_value, xtra_data_key) 
                      in data_value.oldvalue" :key="xtra_data_key">{{ xtra_data_key }} : {{ xtra_data_value }}</li>         
                  </td>
                  <td v-if="!isJson(data_value.oldvalue)">
                    {{ data_value.oldvalue }}
                  </td>

                  <td v-if="isJson(data_value.newvalue)">
                    <li v-for="(xtra_data_value, xtra_data_key) 
                      in data_value.newvalue" :key="xtra_data_key">{{ xtra_data_key }} : {{ xtra_data_value }}</li>         
                  </td>
                  <td v-if="!isJson(data_value.newvalue)">
                    {{ data_value.newvalue }}
                  </td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.data && activeTab=='oldvalues'">
          <v-simple-table
            fixed-header

          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>Data key</strong>
                  </th>
                  <th class="text-left">
                    <strong>Old Value</strong>
                  </th>
                  

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data_value, data_key) in JSON.parse(model.oldAttributes)"
                  :key="data_key"
                >
                  <td>{{ data_key }}</td>
                  <td v-if="isJson(data_value)">
                    <li v-for="(xtra_data_value, xtra_data_key) 
                      in data_value" :key="xtra_data_key">{{ xtra_data_key }} : {{ xtra_data_value }}</li>         
                  </td>
                  <td v-if="!isJson(data_value)">
                    {{ data_value }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.data && activeTab=='newvalues'">
          <v-simple-table
            fixed-header

          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>Data key</strong>
                  </th>
                  <th class="text-left">
                    <strong>New Value</strong>
                  </th>
                  

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data_value, data_key) in JSON.parse(model.attributes)"
                  :key="data_key"
                >
                  <td>{{ data_key }}</td>
                  <td v-if="isJson(data_value)">
                    <li v-for="(xtra_data_value, xtra_data_key) 
                      in data_value" :key="xtra_data_key">{{ xtra_data_key }} : {{ xtra_data_value }}</li>         
                  </td>
                  <td v-if="!isJson(data_value)">
                    {{ data_value }}
                  </td>                 
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>



      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn color="default" @click="hideDialog">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'
import { DateTime, formatDateTime } from '@/lib/helpers'

export default {
  data () {
    return {
      dialogState: false,
      deliveryDateDialog: false,
      
      model: {},
      errors: {},

      activeTab: ''
    }
  },
  watch: {

  },
  computed: {
    isNewItem() {
      return !this.model.id
    },
    created_at() {
      return formatDateTime(DateTime.fromSeconds(this.model.created_at))
    }
  },
  created() {
  },
  methods: {
    isJson(value) {
      if (typeof value === 'object' && value !== null) {
        return true;
      } 
      return false;
    },    
    showDialog(id = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false
      this.model = {}
    },
    setItem(item = {}, reset = false) {
      Object.keys(this.model).forEach(key => {
        if (reset || (key in item)) {
          if (this.model[key].isArray()) {
            this.setItem(this.model[key])
          } else {
            this.model[key] = (key in item) ? item[key] : null
          }
        }
      })
      this.errors = {}      
    },
    getItem() {
      const item = this.model
      return item
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/user-log/${id}`, {
        params: {
        },
      }).then(item => {
        //this.setItem(item, true)
        delete item.product_name
        this.model = item
        this.activeTab = 'general'
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  },
}
</script>
